import * as p from '@clack/prompts'

export function fail(message: string): never {
  p.log.error(message)
  process.exit(1)
}
